var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{key:_vm.updateKey,attrs:{"action":"/file/upload","data":{dir:_vm.dir},"file-list":_vm.fileList,"on-change":_vm.onChange,"on-remove":_vm.onChange,"on-preview":_vm.preview}},[_c('el-button',{attrs:{"size":"mini","type":"primary","plain":""}},[_vm._v("upload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }